import { Absolute, COLOR_SYSTEM, Flex, SHADOW, ToggleButton } from "components/atoms";
import { ToggleButtonVariant } from "components/atoms/ToggleButton";
import React from "react";
import styled from "styled-components";

const DropdownLayout = styled.div`
  position: relative;
`;

export const DropdownMenuItems = styled.ul`
  position: relative;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[0]};
  ${SHADOW.get("4")};
  border-radius: 8px;
  z-index: 100;
  overflow: auto;
  padding-inline-start: 0px;
`;

interface DropdownMenuItemProps {
  width?: string;
  isSelected?: boolean;
}

export const DropdownMenuItem = styled.li<DropdownMenuItemProps>`
  display: flex;
  gap: 20px;
  padding: 8px 12px 8px 12px;
  background-color: ${({ isSelected }) =>
    COLOR_SYSTEM.get("Gray")?.[isSelected ? 10 : 0]};
  cursor: pointer;
  
  &.active,
  &:hover {
    background-color: ${COLOR_SYSTEM.get("Gray")?.[10]};
  }
`;

interface DropdownProps {
  buttonCustomStyle?: React.CSSProperties;
  customStyle?: React.CSSProperties;

  // width?: string;
  // height?: string;
  // maxHeight?: string;
  defaultValue: any;
  selected?: any;
  size?: "Large" | "Medium" | "Small";
  children?: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  buttonStyle?: ToggleButtonVariant;
  onClick?: () => void;
  onBlur?: () => void;
}

const Dropdown: React.FC<DropdownProps> = ({
  // width,
  // height,
  // maxHeight,
  buttonCustomStyle,
  customStyle: itemCustomcustomStyle,
  defaultValue,
  selected,
  children,
  size = "Large",
  active = false,
  disabled = false,
  buttonStyle = "Outlined",
  onClick,
  onBlur,
}) => {
  return (
    <DropdownLayout onBlur={onBlur}>
      <ToggleButton
        color="Gray"
        size={size}
        type="IconWithText"
        variant={buttonStyle}
        active={!disabled}
        icon={active ? "Caret Up Filled" : "Caret Down Filled"}
        right
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        style={buttonCustomStyle}
      >
        {selected ? selected : defaultValue}
      </ToggleButton>
      {active && (
        <Absolute>
          <DropdownMenuItems
            style={{
              ...itemCustomcustomStyle,
            }}
          >
            {children}
          </DropdownMenuItems>
        </Absolute>
      )}
    </DropdownLayout>
  );
};

export default Dropdown;
